import { useEffect, useRef } from "react";
import styles from "./Chat.module.scss";
import { formatTime } from "../../utils/dateUtils";
import { message } from "antd";

const Chat = ({ chatId, messagesData }) => {
  const chatEndRef = useRef(null);

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView();
    }
  }, [messagesData]);

  console.log("chat data", messagesData);

  return (
    <div className={styles.chatContainer}>
      {messagesData?.map((message) => (
        <div
          key={message.id}
          className={
            message.is_from_employee
              ? styles.chatEmployeeMessage
              : styles.chatClientMessage
          }
        >
          {message.content}{" "}
          <span className={styles.date}>{formatTime(message.created_at)}</span>
        </div>
      ))}
      <div ref={chatEndRef} />
    </div>
  );
};

export default Chat;
